export const VISION_INPUT = 'VISION_INPUT' as const;
export const VISION_OUTPUT = 'VISION_OUTPUT' as const;
